import React, { useState } from 'react';

import { Button, ModalHeader, ModalBody, ModalFooter, Row, Typography } from 'cfa-react-components';
import { parseAxiosError } from "services";
import toast from "react-hot-toast";

interface IDeleteCaptureModalProps {
    deleteVerb: string,
    deleteNoun: string, 
    target: any,
    targetFunc: (any) => Promise<any>,
    onHide: () => void,
    refresh: () => void,
}

export function DeleteModal({ deleteVerb, deleteNoun, target, targetFunc, onHide, refresh }: IDeleteCaptureModalProps) {

    const [loading, setLoading] = useState(false);

    const deleteTarget = () => {
        
        setLoading(true);

        targetFunc(target)
            .then(() => {
                refresh();
                onHide();
                toast.success(`${deleteNoun} Deleted`);
            })
            .catch((err) => {
                onHide();
                toast.error(parseAxiosError(err));
                setLoading(false);
            });
    }

    return (<>

        <ModalHeader>
            {deleteVerb} {deleteNoun && deleteNoun + "?"}
        </ModalHeader>

        <ModalFooter>
            <Button variant="outlined" onClick={onHide}>
                Close
            </Button>
            <Button
                variant="filled"
                onClick={deleteTarget}
                loading={loading}
            >
                {loading ? 'Confirming...' : 'Confirm'}
            </Button>
        </ModalFooter>

    </>);
}